module.exports = __webpack_public_path__ + "img/bg-reucirs.80a9d7c0.jpg";